import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import HvSvg from 'src/components/HvSvg';
import uiDux from 'src/redux/ui/';
import appDux from 'src/redux/app/';
import { Header, BackButton, BackIcon, HeaderTitle } from './styled';

const mapStateToProps = (state) => ({
  extendedSidebarData: appDux.selectors.getExtendedSidebarData(state),
  activeEditingAttribute: state.designPro.app.activeEditingAttribute,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      handlePreviousAttributeButtonClick:
        uiDux.actions.handlePreviousAttributeButtonClick,
    },
    dispatch,
  );

export class ExtendedSidebarHeader extends PureComponent {
  static propTypes = {
    extendedSidebarData: PropTypes.object.isRequired,
    activeEditingAttribute: PropTypes.object.isRequired,
    handlePreviousAttributeButtonClick: PropTypes.func.isRequired,
  };

  render() {
    const {
      activeEditingAttribute,
      handlePreviousAttributeButtonClick,
    } = this.props;
    const currentSelectedSidebar = activeEditingAttribute.name;

    return (
      <Header
        data-selenium="extendedSidebarHeader"
        onClick={() => {
          handlePreviousAttributeButtonClick();
        }}
      >
        <BackButton>
          <BackIcon icon="close">
            <HvSvg
              src={require('src/assets/images/right-arrow.svg')}
              disabled={false}
              data-selenium="extendedSidebarBackButton"
            />
          </BackIcon>
        </BackButton>
        <HeaderTitle>Select {currentSelectedSidebar}</HeaderTitle>
      </Header>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExtendedSidebarHeader);
